import { useMutation } from "@tanstack/react-query";
import { DeleteBookingExtraResponse, DeleteBookingExtraResponseSchema } from "../response/DeleteBookingExtraResponse";
import { privateApi } from "../../../api/api";

const API_VERSION = "v4";

const deleteBookingExtra = async (bookingExtraId: string): Promise<DeleteBookingExtraResponse> => {
    const response = await privateApi.delete(`/${API_VERSION}/booking-extra/${bookingExtraId}`);
    return DeleteBookingExtraResponseSchema.parse(response.data);
}

export const useDeleteBookingExtra = () => {
    return useMutation({
        mutationFn: deleteBookingExtra,
        onError: (error) => {
            console.error('Error deleting booking extra:', error);
        }
    });
}
